import React from "react";
import { t } from "i18next";
import ImageIndicator from "../../../../components/SVGComponents/ImageIndicator";
import TextIndicator from "../../../../components/SVGComponents/TextIndicator";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { useContext } from "react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import {
  DirectionalHint,
} from "@fluentui/react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { NONXRAYMODALITIES } from "../../../../constants/Constants";


const InstructionStack = ({ instructions = [] }) => {
  const isEmpty = instructions.length === 0;
  const {
    inputValue,
    maskImages
  } = useContext(studyReportContext);
  const { modality} = useContext(studyReportContext);

  return (
    <div
      className="instruction-tab"
      style={{
        height: "67px",
        width: "100%",
        backgroundColor: "transparent",
       
        margin: "0 0.5%",
        marginBottom: "0.5%",

        display: "flex",
        boxSizing: "border-box",
      }}
    >
      <style jsx global>{`
        .instruction-tab {
          scrollbar-width: thin;
          scrollbar-color: #7d7d7d #bcbbbb;
        }
        .instruction-tab::-webkit-scrollbar {
          width: 6px;
        }
        .instruction-tab::-webkit-scrollbar-track {
          border-radius: 8px;
        }
        .instruction-tab::-webkit-scrollbar-thumb {
          border-radius: 8px;
        }
      `}</style>

      
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "space-between",
          alignItems: "stretch",
        }}
      >
        {/* Instruction Text Area */}
        <div
          style={{
            flex: 1,
            padding: "5px 10px",
            fontSize: "13px",
            fontFamily: "Segoe UI",
            overflowY: "auto",
            color: "#4F4444",
            backgroundColor: "#BCBBBB",
            border: "1px solid #ccc",
            borderRadius: "8px",
            boxSizing: "border-box",
          }}
        >
          {isEmpty ? (
            <p>{t("placeholder.no-instruction-available")}</p>
          ) : (
            instructions.map((inst, idx) => (
              <div key={idx}>
                <p
                  style={{
                    fontWeight: inst.isNote ? "500" : "normal",
                    fontStyle: inst.isNote ? "italic" : "normal",
                    margin: 0,
                    wordBreak: "break-word",
                  }}
                >
                  {inst.prompt}
                </p>
              </div>
            ))
          )}
        </div>

        {/* Button Area (Right) */}
        <div
          style={{
            width: "28px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "5px 6px", 
          }}
        > 
          <CustomToolTipHost 
            content={
                    !inputValue.trim() ? 
                      "No Prompt selected"
                      : "Prompt selected"} 
            id="Text Indicator"
            directionalHint={DirectionalHint.leftCenter}
            tooltipProps={{
              calloutProps: {
                styles: {
                  beak: { background: "#252525;" },
                  beakCurtain: { background: "#252525;" },
                  calloutMain: { background: "#252525;" },
                  borderRadius: "20%",
                },
              },
            }}
          >
              <div
                style={{
                  cursor: "default",
                }}
                aria-label="Text Indicator"
              >
                <TextIndicator isText={inputValue.trim()} />
              </div>
          </CustomToolTipHost> 
          {NONXRAYMODALITIES.includes(modality) && <CustomToolTipHost 
           content={
              maskImages.length === 0
                ? "No image selected"
                : `${Object.values(maskImages).length} image${Object.values(maskImages).length > 1 ? "s" : ""} selected`
            } 
            id="Image Indicator"
            directionalHint={DirectionalHint.leftCenter}
            tooltipProps={{
              calloutProps: {
                styles: {
                  beak: { background: "#252525;" },
                  beakCurtain: { background: "#252525;" },
                  calloutMain: { background: "#252525;" },
                  borderRadius: "20%",
                  zIndex: 9999,
                },
              },
            }}
          >
              <div
                style={{
                  cursor: "default",
                }}
                aria-label="Image Indicator"
              >
                <ImageIndicator isImage={Object.values(maskImages).length > 0} />
              </div>
          </CustomToolTipHost>
  }
        </div>
      </div>
    </div>
  );
};


export default InstructionStack;
